// extracted by mini-css-extract-plugin
module.exports = {"documentIdCell":"documentIdCell__wOKc4","documentId":"documentId__UyKFn","warning":"warning__x0nVC","negative":"negative__ZDZJy"};